// Экспорт сессии редактора маршрутов (нарисованная линия + вейпоинты) в
// GPX-файл прямо на клиенте - у нарисованных в редакторе маршрутов нет
// исходного файла в MinIO (gpx_object_key всегда NULL), в отличие от
// маршрутов, загруженных через /admin/routes из готового GPX. См.
// backend/app/routes/router.py::download_route_gpx.
export interface GpxWaypoint {
  name: string;
  description?: string | null;
  poi_type: string;
  latitude: number;
  longitude: number;
}

function escapeXml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&apos;");
}

export function buildGpxXml(
  name: string,
  points: [number, number][],
  waypoints: GpxWaypoint[]
): string {
  const trackPoints = points
    .map(([lon, lat]) => `      <trkpt lat="${lat}" lon="${lon}"></trkpt>`)
    .join("\n");

  const wpts = waypoints
    .map((wp) => {
      const parts = [
        `  <wpt lat="${wp.latitude}" lon="${wp.longitude}">`,
        `    <name>${escapeXml(wp.name)}</name>`,
        `    <type>${escapeXml(wp.poi_type)}</type>`,
      ];
      if (wp.description) parts.push(`    <desc>${escapeXml(wp.description)}</desc>`);
      parts.push("  </wpt>");
      return parts.join("\n");
    })
    .join("\n");

  return [
    '<?xml version="1.0" encoding="UTF-8"?>',
    '<gpx version="1.1" creator="EcoWay" xmlns="http://www.topografix.com/GPX/1/1">',
    "  <trk>",
    `    <name>${escapeXml(name)}</name>`,
    "    <trkseg>",
    trackPoints,
    "    </trkseg>",
    "  </trk>",
    wpts,
    "</gpx>",
  ]
    .filter(Boolean)
    .join("\n");
}

export function gpxFileName(name: string): string {
  return `${sanitizeFileName(name)}.gpx`;
}

function sanitizeFileName(name: string): string {
  return (name.trim() || "route").replace(/[\\/:*?"<>|]/g, "_");
}

export function downloadGpx(name: string, points: [number, number][], waypoints: GpxWaypoint[]): void {
  const xml = buildGpxXml(name, points, waypoints);
  const blob = new Blob([xml], { type: "application/gpx+xml" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${sanitizeFileName(name)}.gpx`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
